import api from '@/services/api';

const CompanyContractTagUpdate = {
  updateCompanyContractTag: (companyContractTagId, companyContractTagName, color, remarks) => {
    return api.post('update_company_contract_tag/', {
      companyContractTagId: companyContractTagId,
      companyContractTagName: companyContractTagName,
      color: color,
      remarks: remarks
    });
  },
  deleteCompanyContractTag: (companyContractTagId) => {
    return api.post('delete_company_contract_tag/', {
      companyContractTagId: companyContractTagId
    });
  }
};

export default CompanyContractTagUpdate;
